module.exports = __webpack_public_path__ + "static/media/end_consultation.a8257c56.svg";